var map = {
	"../pages/drug/drug.module": [
		351,
		0
	],
	"../pages/login/login.module": [
		352,
		3
	],
	"../pages/newdrug/newdrug.module": [
		353,
		2
	],
	"../pages/nhf/nhfdrug.module": [
		354,
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 238;



//////////////////
// WEBPACK FOOTER
// ./src async
// module id = 238
// module chunks = 4